import React from 'react';
import { ZapIcon, CodeIcon, DatabaseIcon } from '../components/Icons';
import PageWrapper from '../components/PageWrapper';

const FeatureItem: React.FC<{icon: React.ReactNode; text: string}> = ({ icon, text }) => (
    <li className="flex items-center space-x-4">
        <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-gradient-to-br from-[var(--gradient-from)] to-[var(--gradient-to)] text-white">
            {icon}
        </div>
        <span className="text-lg text-[var(--text-secondary)]">{text}</span>
    </li>
);

const AIAgentsPage: React.FC = () => {
  return (
    <PageWrapper>
      <div className="py-20 sm:py-32">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[var(--panel-bg)] backdrop-blur-sm border border-[var(--border-color)] rounded-2xl p-8 md:p-12 lg:p-16 max-w-4xl mx-auto">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-extrabold text-[var(--text-primary)]">
                Codey's AI Agents — Coming Soon!
              </h1>
              <p className="mt-6 text-lg text-[var(--text-secondary)]">
                We’re preparing to introduce the next evolution of Codemine.
              </p>
            </div>

            <div className="mt-12 text-left max-w-3xl mx-auto text-[var(--text-secondary)] text-lg">
                <p>
                    Our upcoming AI Agents are specialized assistants, trained to work alongside you and amplify your productivity. Each agent will be purpose-built to:
                </p>

                <ul className="space-y-6 my-8">
                    <FeatureItem icon={<ZapIcon />} text="Automate workflows and handle routine tasks seamlessly" />
                    <FeatureItem icon={<CodeIcon />} text="Create content that matches your goals and brand voice" />
                    <FeatureItem icon={<DatabaseIcon />} text="Fuel business growth with actionable, data-driven insights" />
                </ul>

                <p>
                    Currently in advanced training, these agents are being fine-tuned to deliver speed, intelligence, and reliability — built for creators, teams, and businesses that want to move faster.
                </p>
            </div>
            
            <div className="mt-12 text-center">
                 <p className="text-xl italic text-[var(--text-primary)]">
                   ✨ Stay tuned. The future of intelligent assistance is about to launch.
                </p>
            </div>

          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default AIAgentsPage;
